import { NappEnvironmentConfiguration } from '~/app/config/environments-configuration';
import { APP_BASE_URL_KEY } from '@softwarehaus/util-angular-configuration';

export const LOCAL_NAPOLEON_ENVIRONMENT_CONFIGURATION: NappEnvironmentConfiguration = {
  environmentName: 'local',
  [APP_BASE_URL_KEY]: 'http://localhost:4200',
  title: 'SOFTWAREHAUS 08EINS',
  theme: 'default',
  defaultLangISO: 'de',
  api: {
    clientId: 'AulX7u8l4M',
    clientSecret: 'd9dc852e6cf8726c77e0e91d3015d5b760aab6a2bf39a519e8ea11145feb5411',
    baseServiceUrl: 'http://localhost:1080/api',
  },
  captchaSiteKey: '6Lc7wgAaAAAAABOGkMnsEQUH3k7G24vbHjGUldnL',
  analyticsUrl: 'https://console.firebase.google.com/project/napoleon-c6fd5/overview',
  appUrl: 'http://localhost:4200',
  footer: {
    customer: '08EINS AG SOFTWAREHAUS',
    phoneNr: '+41 81 252 30 30',
    website: 'www.softwarehaus.net',
    email: 'info@softwarehaus.net',
    instagram: 'https://www.instagram.com/softwarehaus_08eins/',
    facebook: 'https://www.facebook.com/08eins/',
    linkedIn: 'https://www.linkedin.com/company/softwarehaus/',
    type: 'default',
  },
  availableModules: {
    feed: true,
    document: true,
    employees: true,
  },
  availableFeatures: {
    feed: {
      location: true,
      showPostType: true,
      approve: true,
      allowVideoUpload: true,
      mention: true,
      report: true,
    },
    header: {
      logoRedirectMyFeed: false,
    },
    push: {
      autoEnable: false,
      unregisteredDevices: false,
    },
    employee: {
      showFirstname: true,
      showLastname: true,
      showLocation: true,
      showDepartment: true,
      showFunctionality: true,
    },
  },
  cloudinary: {
    cloudName: 'cloud-08eins',
    uploadPreset: 'c4jbrhj1',
    prefix: 'development',
  },
};
